import React from 'react';
import Services from '../components/Services';
import Technologies from '../components/Technologies';
import { motion } from 'framer-motion';

const ServicesPage = () => {
  return (
    <div className="pt-32 bg-transparent relative">
      <div className="container mx-auto px-6 max-w-7xl pt-16 text-center">
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-5xl md:text-6xl font-bold text-slate-900 mb-6"
        >
          Comprehensive <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">IT Services</span>
        </motion.h1>
      </div>
      <Services />
      <Technologies />
    </div>
  );
};

export default ServicesPage;
